import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  ApprovalStatus,
  useGetUsersByAccountAndSoftwareQuery,
  usePostInvoiceAmortisationMutation,
  useRejectInvoiceAmortisationMutation,
  UserSelection,
} from 'generated/graphql'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import { useHistory, useLocation, useParams } from 'react-router'
import './InvoiceAmortisation.scss'

import CardExpansion from '@ifca-root/react-component/src/components/CardList/CardExpansion'
import { Grid, List, ListItem, ListItemText } from '@material-ui/core'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { dateFormat, formatDate } from 'helpers/StringNumberFunction/FormatDate'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { InvoiceAmortisationDetailContent } from './InvoiceAmortisationDetailContent'
import { InvoiceAmortisationItemContent } from './InvoiceAmortisationDetailItemContent'
import { AccountFooter } from '@ifca-root/react-component/src/components/Footer/AccountFooter'
import { RejectDialog } from 'components/Dialog/RejectDialog'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'

export const InvoiceAmortisationDetail = (props: any) => {
  let history = useHistory()
  const { CompanyID, AmortisationID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  let location = useLocation()
  const editData = location?.state as any

  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)
  const [openRejectDialog, setOpenRejectDialog] = useState(false)
  const [clickReject, setIsReject] = useState(false)
  const [rejectDialogInput, setRejectDialogInput] = useState({
    RejectionRemark: '',
  })
  const [postDialog, setPostDialog] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  let itemData = []
  itemData = editData?.JournalProcessingItem

  const {
    loading: getUsersByAccountAndSoftwareLoading,
    error: getUsersByAccountAndSoftwareError,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
    variables: {
      superUserBool: UserSelection.All,
    },
  })

  const [
    postInvoiceAmortisation,
    { loading: postInvoiceAmortisationLoading },
  ] = usePostInvoiceAmortisationMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setPostDialog(true)
    },
    onCompleted: () => {
      history.push(`/account-receivable/${CompanyID}/invoice-amortisation`)
      setSnackBarMsg(SystemMsgs.postNewRecord())
      setOpenSnackBar(true)
    },
  })

  const [
    rejectInvoiceAmortisation,
    { loading: RejectInvoiceAmortisationLoading },
  ] = useRejectInvoiceAmortisationMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: () => {
      history.push(`/account-receivable/${CompanyID}/invoice-amortisation`)
      setSnackBarMsg(SystemMsgs.rejectNewRecord())
      setOpenSnackBar(true)
    },
  })

  const isSubmittingRef = useRef(false)

  const onSubmitApprove = (listPostIDs, status) => {
    if (isSubmittingRef.current) return
    isSubmittingRef.current = true
    postInvoiceAmortisation({
      variables: {
        AmortisationIDs: AmortisationID,
        CompanyID: CompanyID,
        ApprovalStatus: status,
      },
    }).finally(() => {
      isSubmittingRef.current = false
    })
  }

  const onSubmitReject = () => {
    rejectInvoiceAmortisation({
      variables: {
        AmortisationIDs: AmortisationID,
        input: {
          RejectionRemark: rejectDialogInput?.RejectionRemark,
        },
      },
    })
  }

  useEffect(() => {
    if (clickReject) {
      onSubmitReject()
    }
  }, [clickReject])

  const totalAmountAmorItem = editData?.AmortisationItem?.reduce(
    (total, currentValue) => (total = total + currentValue.InvoiceItem?.Amount),
    0
  )

  return (
    <>
      {postInvoiceAmortisationLoading && <Loading />}
      {RejectInvoiceAmortisationLoading && <Loading />}
      {getUsersByAccountAndSoftwareLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(`/account-receivable/${CompanyID}/invoice-amortisation`)
        }}
        smTitle="Account Receivable"
        title={user?.companyName}
        routeSegments={[
          { name: 'Account Receivable' },
          { name: 'Account Receivable' },
          { name: 'Invoice Amortisation', current: true },
        ]}
        rightRouteSegments={[
          {
            name:
              editData?.ApprovalStatus === 'COMPLETED'
                ? 'Approved'
                : editData?.ApprovalStatus === 'CANCELLED'
                ? 'Cancelled'
                : 'Submitted',
            current: true,
          },
        ]}
      />

      <DynamicSubHeader
        title={
          <span className="c-orange">
            <span style={{ fontWeight: 'bold' }}>
              {`${editData?.Invoice?.DocNo} | ${editData?.Invoice?.DebtorAccount
                ?.DebtorName ?? ''}`}
            </span>
          </span>
        }
        rightText={
          <span className="text-overflow" style={{ fontSize: '11px' }}>
            {dateFormat(editData?.Invoice?.DocDate)}
          </span>
        }
        infoLine={
          <div
            className="text-overflow"
            style={{ fontSize: '11px', width: '270px' }}
          >
            {editData?.Invoice?.Description}
          </div>
        }
        rightInfoLine={
          <div className="text-overflow" style={{ fontSize: '11px' }}>
            {amtStr(totalAmountAmorItem)}
          </div>
        }
      />
      <ContentWrapper multiDynamicInfo float footer>
        <CardContents>
          <InvoiceAmortisationDetailContent
            listEl={editData}
            listStatus={'COMPLETED'}
            userList={getUsersByAccountAndSoftware}
            mode={'detail'}
          />
        </CardContents>
        {editData?.AmortisationItem?.map((x, index) => {
          return (
            <>
              <List className="core-list" style={{ paddingBottom: '0px' }}>
                <CardExpansion
                  customColor
                  backColor={'#fff4dc'}
                  backPanelColor="#fff4dc"
                  className="space"
                  summary={
                    <ListItem
                      key={index}
                      style={{ backgroundColor: '#fff4dc' }}
                    >
                      <ListItemText
                        primary={
                          <>
                            <span className={`c-orange xsTitle flex-space`}>
                              {x?.InvoiceItem?.BillItem?.MasterCOA?.Code}
                            </span>
                            <span
                              style={{
                                color: 'orange',
                                fontSize: '12px',
                              }}
                            >
                              {amtStr(x?.InvoiceItem?.Amount)}
                            </span>
                          </>
                        }
                        secondary={
                          <>
                            <Grid spacing={1} container>
                              <Grid item xs={12}>
                                <span className={`desc flex-space`}>
                                  {x?.InvoiceItem?.BillItem?.MasterCOA?.Name}
                                </span>
                              </Grid>
                            </Grid>
                            <Grid spacing={1} container>
                              <Grid item xs={12}>
                                <span className={`desc flex-space`}>
                                  {`${x?.MasterCOA?.Code} | ${x?.MasterCOA?.Name}`}
                                </span>
                              </Grid>
                            </Grid>
                            <Grid spacing={1} container>
                              <Grid item xs={6}>
                                <span className={`desc`}>
                                  Contract Start Date:{' '}
                                  <b>
                                    {x?.ContractStartDate
                                      ? formatDate(x.ContractStartDate)
                                      : '-'}
                                  </b>
                                </span>
                              </Grid>
                              <Grid item xs={6}>
                                <span className={`desc`}>
                                  Contract End Date:{' '}
                                  <b>
                                    {x?.ContractEndDate
                                      ? formatDate(x.ContractEndDate)
                                      : '-'}
                                  </b>
                                </span>
                              </Grid>
                            </Grid>

                            <Grid spacing={1} container>
                              <Grid item xs={6}>
                                <span className={`desc`}>
                                  First Amort Date:{' '}
                                  <b>
                                    {x?.FirstAmortDate
                                      ? formatDate(x.FirstAmortDate)
                                      : '-'}
                                  </b>
                                </span>
                              </Grid>
                              <Grid item xs={6}>
                                <span className={`desc`}>
                                  Months: <b>{x?.Month ?? '-'}</b>
                                </span>
                              </Grid>
                            </Grid>
                          </>
                        }
                      />
                    </ListItem>
                  }
                >
                  <InvoiceAmortisationItemContent
                    listItem={x?.AmortisationItemDetail}
                  />
                </CardExpansion>
              </List>
            </>
          )
        })}
      </ContentWrapper>

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />

      {editData?.ApprovalStatus === 'SUBMIT' ? (
        <AccountFooter
          options={[
            {
              name: 'Reject',
              onClick: () => {
                setOpenRejectDialog(true)
              },
              color: 'secondary',
              props: {
                disabled:
                  postInvoiceAmortisationLoading ||
                  RejectInvoiceAmortisationLoading,
                // handlePermDisabled({
                //   companyID: CompanyID,
                //   permEnum:
                //     AcctPermission.GeneralLedgerJournalProcessingApproveReject,
                // }),
              },
            },
            {
              name: 'Approve',
              onClick: () => {
                onSubmitApprove(AmortisationID, ApprovalStatus.Completed)
              },
              color: 'primary',
              props: {
                disabled:
                  postInvoiceAmortisationLoading ||
                  RejectInvoiceAmortisationLoading,
                // handlePermDisabled({
                //   companyID: CompanyID,
                //   permEnum:
                //     AcctPermission.GeneralLedgerJournalProcessingApproveReject,
                // }),
              },
            },
          ]}
        />
      ) : null}

      <RejectDialog
        data={editData}
        openRejectDialog={openRejectDialog}
        setOpenRejectDialog={setOpenRejectDialog}
        setRejectDialogInput={setRejectDialogInput}
        setIsReject={setIsReject}
      />
    </>
  )
}
